var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selector-/-Date",
    transform: "translate(-9.000000, -9.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(9.864865, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13853467,1.20000504 L10.3088368,1.20000504 C10.4527261,1.20000504 10.5906742,1.26322127 10.6924872,1.37573969 C10.7942189,1.48826711 10.8513514,1.64087167 10.8513514,1.80001026 L10.8513514,11.4000578 C10.8513514,11.5591784 10.7942189,11.7118189 10.6924872,11.8243193 C10.5906742,11.9368198 10.4527261,12 10.3088368,12 L0.542566591,12 C0.398670845,12 0.260665767,11.9368198 0.158914592,11.8243193 C0.057163417,11.7118189 0,11.5591784 0,11.4000578 L0,1.80001026 C0,1.64087167 0.057163417,1.48826711 0.158914592,1.37573969 C0.260665767,1.26322127 0.398670845,1.20000504 0.542566591,1.20000504 L2.71284435,1.20000504 L2.71284435,0 L3.79797916,0 L3.79797916,1.20000504 L7.05339173,1.20000504 L7.05339173,0 L8.13853467,0 L8.13853467,1.20000504 Z M1.08513807,4.80001836 L1.08513807,10.8000184 L9.76624096,10.8000184 L9.76624096,4.80001836 L1.08513807,4.80001836 Z M2.17027287,6.0000198 L3.25541582,6.0000198 L3.25541582,7.20003024 L2.17027287,7.20003024 L2.17027287,6.0000198 Z M4.88312211,6.0000198 L5.96825692,6.0000198 L5.96825692,7.20003024 L4.88312211,7.20003024 L4.88312211,6.0000198 Z M7.5959632,6.0000198 L8.68113056,6.0000198 L8.68113056,7.20003024 L7.5959632,7.20003024 L7.5959632,6.0000198 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.682175ea8638b6e15e9e16357d52df06.svg";
export { ForwardRef as ReactComponent };